<div class="upload-container" appDragDrop (fileDropped)="onFileDropped($event)">
    <p>Browse or Drag and Drop .jpg, .png, .gif</p>
    <button mat-raised-button (click)="fileInput.click()">Browse File</button>
    <input type="file" #fileInput (change)="onFileSelected($event)" style="display:none">
</div>
